<template>
  <div
    class="upload-btn-wrap"
    :class="canUploadFile ? '' : 'gray-upload'"
    @click="handleClick"
  >
    <input
      ref="uploadInput"
      :uploadType="uploadType"
      type="file"
      class="uploadInput"
      :multiple="multiple"
      :disabled="!canUploadFile"
      :accept="accept"
      @change="handleInputChange"
    />
    <span class="btn">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'UploadBtn',
  props: {
    text: {
      type: String,
      default: '上传文件'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    uploadType: {
      type: Number,
      default: 0
    },
    canUploadFile: {
      type: Boolean,
      default: true
    },
    accept: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  methods: {
    handleClick() {
      this.$refs.uploadInput.dispatchEvent(new MouseEvent('click'));
    },
    handleInputChange(ev) {
      console.log(ev, '拿到的======');
      const fileList = ev.target.files;
      this.$emit('on-success', fileList);
      ev.target.value = '';
    },
    reset() {
      this.$refs['uploadInput'].value = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-btn-wrap {
  padding: 10px 15px;
  border-radius: 6px;
  background-color: #488ffa;
  white-space: nowrap;
  display: inline-block;
  cursor: pointer;
  line-height: 1;
  .uploadInput {
    display: none;
  }
  .btn {
    color: #fff;
    font-size: 14px;
  }
}
.gray-upload {
  background: #999;
  opacity: 0.5;
}
</style>
